export enum Flags {
    APR_REPRESENTATIVE = "op_RepresentativeAPR",
    MAINTENANCE_WINDOW = "op_Maintenance",
}

export type FlagValue = boolean | object | number;
